import { Add, DeleteOutlined } from '@mui/icons-material';
import React from 'react';
import '../../components/app/common.scss';
import toList from './ComponentUtil';
import CustomButton from './CustomButton';
import CustomSelect from './customSelect';
import CustomTextField from './CustomTextField';


function CustomMultiInput({ value, options, onChange = undefined , parent = undefined }) {

    const addNewItem = (e) => {
        if(parent) {
            parent.value = [...value,{ type: '', value: ''}]
            onChange(e);
        }
    }
    const removeItem = (e, i) => {
        if(parent) {
            value.splice(i, 1);
            parent.value = [...value]
            onChange(e);
        }
    }
    return (
        <div className='custom-multi-input-component'>
            {
                toList(value, undefined, (item, i) =>
                    <div className='multi-input-wrp' key={i}>
                        <div className='input-wrp'>
                            <CustomSelect name='type' parent={item} prop='type' value={item?.type} options={options} onChange={onChange} required={true} />
                            <CustomTextField name='value' parent={item} value={item?.value} onChange={onChange} required={true} />
                        </div>
                        <div className='add-remove-wrp'>
                            {i === 0 ? <CustomButton name='Add' icon={<Add />} onClick={addNewItem} /> : <DeleteOutlined onClick={(e) => removeItem(e, i)} />}
                        </div>
                    </div>
                )
            }
        </div>
    );
}

export default CustomMultiInput;